import { useEffect, useState } from 'react';
import { fetchMyPackageApi } from '../api/packages.api';

let cachedEntitlement = undefined;
let inflight = null;
const listeners = new Set();

const notify = (value) => {
  cachedEntitlement = value;
  listeners.forEach((listener) => listener(value));
};

const loadMyPackage = () => {
  if (inflight) {
    return inflight;
  }

  inflight = fetchMyPackageApi()
    .then((current) => {
      notify(current);
      return current;
    })
    .catch(() => {
      notify(null);
      return null;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
};

export const refreshMyPackage = () => {
  inflight = null;
  return loadMyPackage();
};

export const useMyPackage = () => {
  const [entitlement, setEntitlement] = useState(cachedEntitlement === undefined ? null : cachedEntitlement);

  useEffect(() => {
    listeners.add(setEntitlement);
    if (cachedEntitlement !== undefined) {
      setEntitlement(cachedEntitlement);
    } else {
      loadMyPackage();
    }
    return () => {
      listeners.delete(setEntitlement);
    };
  }, []);

  return entitlement;
};
